import actions from "./preferencesActions";

const language = navigator.language;
const splitLanguage = language && language.split("-");
const locale = splitLanguage && splitLanguage.length > 0 && splitLanguage[1];

const initialState = {
  language,
  locale,
};

export const STATE_KEY = "preferences";

const preferencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case actions.SET_LOCALE:
      return {
        ...state,
        locale: action.payload,
      };
    default:
      return state;
  }
};

export default preferencesReducer;
